/**
 * ErrorPage (route: "/404" and catch-all "*")
 * Shown for unknown URLs and for any feature that is intentionally disabled
 * until launch (see the router for the full list).
 */
import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Error from '../../components/404';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';

const ErrorPage = () => {
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={'404'} pagesub={'404'} />
      <Error />
      <Footer footerClass={'wpo-ne-footer-2'} />
      <Scrollbar />
    </Fragment>
  );
};
export default ErrorPage;
